/**
 * True for Tyson Properties enterprise, agencies, branches, and agents.
 *
 * An explicit `user.brand` (set by the admin Demo Environment builder) wins
 * first, so a demo can render Tyson formatting regardless of its name; we fall
 * back to the historical name/email string match for real Tyson accounts.
 */
export function isTysonOrg(user) {
  if (!user || typeof user !== 'object') return false;
  if (user.brand === 'tyson') return true;
  if (user.brand && user.brand !== 'tyson') return false;
  const haystack = [
    user.enterpriseName,
    user.agencyName,
    user.name,
    user.email,
    user.agencyStats?.agencyName,
  ]
    .filter(Boolean)
    .map((s) => String(s).toLowerCase());
  return haystack.some((s) => s.includes('tyson'));
}
